// extracted by mini-css-extract-plugin
module.exports = {"popover":"CommentEditor_popover__XyRzS"};